import { Stack, Tooltip, Typography } from "@mui/material";
import { isTextEllipsed } from "../../../utils/general_utils";

export const UserWithPanTooltip = () => {
  return (
    <Tooltip
      title={"Changes were made to this contact"}
      placement="bottom"
      arrow
      sx={{
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 400,
        "&:hover": {
          visibility: "visible",
          opacity: 1,
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        onMouseEnter={(event: React.MouseEvent<HTMLDivElement>) => {
          const target = event.currentTarget;
          isTextEllipsed(target);
        }}
      >
        <Typography
          component="span"
          variant="body2"
          color="#B3BECE"
          noWrap={true}
          width="38px"
        >
          Edited
        </Typography>
      </Stack>
    </Tooltip>
  );
};
